import { NUMBER_OF_MONTHS_DATES_OUTSIDE_RANGE } from '@components/views/flight/constants';
import {
  DateType,
  formatMomentDate,
  formatShortLocalDate,
  getCurrentDate,
  getNMonthsLater,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';

export const getDateRangePickerPlaceholder = (
  startDate: DateType | null,
  endDate: DateType | null
) => {
  if (!startDate && !endDate) {
    return;
  } else if (startDate && !endDate) {
    return (
      formatShortLocalDate(formatMomentDate(startDate)) + ' - Dönüş Tarihi'
    );
  } else {
    return (
      formatShortLocalDate(formatMomentDate(startDate)) +
      ' - ' +
      formatShortLocalDate(formatMomentDate(endDate))
    );
  }
};

export const getSingleDatePickerPlaceholder = (date: DateType | null) => {
  if (!date) {
    return '';
  } else {
    return formatMomentDate(date);
  }
};

export const isFlightReturnDateOutsideRange = (
  day: DateType,
  startDate: DateType | null
) =>
  !isInclusivelyAfterDay(day, getCurrentDate()) ||
  (startDate
    ? isInclusivelyAfterDay(
        day,
        getNMonthsLater(startDate, NUMBER_OF_MONTHS_DATES_OUTSIDE_RANGE)
      )
    : false);
